import { useEffect, useState } from "react";
import { api, API } from "@/lib/api";

let _version = null;
const _subs = new Set();
const set = (v) => { _version = v; _subs.forEach((fn) => fn(v)); };

export const logoSrc = (v) => `${API}/public/logo.png?v=${v || "default"}`;

export const useBrandLogo = () => {
  const [v, setV] = useState(_version);
  useEffect(() => {
    _subs.add(setV);
    if (_version === null) {
      _version = "default";
      api.get("/public/branding", { silent: true }).then((r) => set(r.data.version)).catch(() => {});
    }
    return () => { _subs.delete(setV); };
  }, []);
  return logoSrc(v);
};

export const setBrandVersion = (v) => {
  set(v);
  document.querySelectorAll("link[rel='apple-touch-icon'], link[rel='icon']").forEach((l) => {
    l.href = l.href.split("?")[0] + `?v=${v}`;
  });
};
